const toNumber = (value) => Number(value || 0);

export const getCCInvoiceAmounts = (invoice) => {
  const baseAmount = toNumber(invoice?.inv_amount);
  const taxRate = toNumber(invoice?.tax_rate);
  const taxAmount = invoice?.tax_amount !== null && invoice?.tax_amount !== undefined
    ? toNumber(invoice.tax_amount)
    : baseAmount * taxRate;
  const grossAmount = baseAmount + taxAmount;

  return {
    baseAmount,
    taxRate,
    taxAmount,
    grossAmount,
  };
};